import * as React from 'react';
import { Icons } from '@telstra-connect/assets';
import './icons.less';

export type IconSizes
    = 'xxs-16'
    | 'xs-20'
    | 'sm-24'
    | 'sm-32'
    | 'sm-36'
    | 'md-50'
    | 'md-64'
    | 'lg-85';

const defaultSize: IconSizes = 'xs-20';

interface IIconProps {
    name: Icons.TelstraIconKeys;
    size?: IconSizes;
    className?: string;
    title?: string;
    iconRef?: (iconRef: HTMLElement) => void;
    description?: string;
    onMouseEnter?: React.MouseEventHandler<HTMLElement>;
    onMouseLeave?: React.MouseEventHandler<HTMLElement>;
    onClick?: React.MouseEventHandler<HTMLElement>;
}

export const IconTC: React.FC<IIconProps> = (props: IIconProps) => (
    <i className={`tc-im-icon ${props.name} tc-icon-${props.size || defaultSize} ${props.className}`}
        title={props.title}
        ref={props.iconRef}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        onClick={props.onClick}
        aria-label={props.description}
        aria-hidden />
);

IconTC.displayName = 'IconTC';

export type IconKeys = Icons.TelstraIconKeys;
